
<div class="scroll-container" :style="{ maxHeight: modalMaxHeight }">
  <slot />
</div>
